import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,_vm._b({attrs:{"width":"400","transition":"scale-transition","origin":"middle center"},on:{"click:outside":function($event){return _vm.$emit('closeModal')}}},'v-dialog',_vm.$attrs,false),[_c(VCard,[(_vm.title)?_c('h6',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.hasButtons)?_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }